<template>
  <a class="py-1.5 pr-3 pl-5 flex justify-between selected-item-menu-shadow hover:text-inherit" :href="href">
    {{ title }}
    <div class="ml-2">
      <svg class="w-5 h-5 inline-block" focusable="false" aria-hidden="true" viewBox="0 0 24 24">
        <path d="M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z"></path>
      </svg>
    </div>
  </a>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  props: {
    title: { type: String, required: true },
    href: { type: String, required: true },
  },
});
</script>

<style scoped>
@tailwind base;
@tailwind components;
@tailwind utilities;

.selected-item-menu-shadow {
  border-color: #0000001a;
}

.selected-item-menu-shadow:hover {
  border-color: white;
  box-shadow: 0 0 5px 0 #0f0c0c;
}
</style>
